import { TextField } from "@mui/material";

const FormInput = ({
  label,
  name,
  type,
  value,
  variant = "outlined",
  onChange,
  required = true,
  multline,
  InputProps,
  placeholder,
  disabled,
  onBlur,
  inputProps,
  onFocus,
  spacing = true,
  contentEditable = true,
  sx,
}) => {
  const autoComplete = type === "password" ? "current-password" : "on";
  return (
    <TextField
      onBlur={onBlur}
      onFocus={onFocus}
      disabled={disabled}
      className={spacing ? "my-2" : ``}
      multiline={multline}
      rows={multline ? 5 : 3}
      type={type}
      variant={variant}
      label={label}
      name={name}
      fullWidth
      value={value}
      inputProps={inputProps}
      InputProps={InputProps}
      required={required}
      onChange={onChange}
      autoComplete={autoComplete}
      placeholder={placeholder}
    />
  );
};

export default FormInput;
